export default __webpack_public_path__ + "static/media/ImageCommingSoon.10329592.png";